export function formatPassFailLabel(isFailing, t) {
  return isFailing ? t("common.fail", "Fail") : t("common.pass", "Pass");
}

export function formatPassFailValue(value, t, fallback = "--") {
  if (!value) return fallback;
  return formatPassFailLabel(value !== "pass", t);
}

export function getQualityStatusPillClasses(status) {
  if (status === "pass") {
    return "bg-emerald-700";
  }

  return "bg-orange-700";
}

export function resolveCardiacQualityStatus(hrQuality, isPassingQuality) {
  if (hrQuality == null) {
    return null;
  }

  return isPassingQuality(hrQuality) ? "pass" : "fail";
}

export function resolveRespiratoryQualityStatus(rrSignalQuality) {
  return rrSignalQuality === "pass" || rrSignalQuality === "fail"
    ? rrSignalQuality
    : null;
}

export function isFailedCheck(value) {
  return typeof value === "string" && value.trim().toLowerCase() === "fail";
}

export function getRespiratoryQualityMessage(rrSignalQuality, t) {
  if (rrSignalQuality !== "fail") return null;
  return {
    title: t("result.resp.qualityFailTitle", "Low respiratory signal quality."),
    subtitle: t("result.resp.qualityFailSubtitle", "Please try again."),
  };
}

export function getHeartRateQualityMessage(hrQuality, isPassingQuality, t) {
  if (hrQuality == null || isPassingQuality(hrQuality)) return null;
  return {
    title: t("result.pulse.qualityFailTitle", "Low heart-rate signal quality."),
    subtitle: t("result.pulse.qualityFailSubtitle", "Please try again."),
  };
}
